import { useLang } from "@/lib/i18n";
import { useReveal } from "@/lib/useReveal";

const PORTRAITS = [
  "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=600",
  "https://images.pexels.com/photos/31869537/pexels-photo-31869537.jpeg?auto=compress&w=600",
  "https://images.unsplash.com/photo-1544005313-94ddf0286df2?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
];

export const Testimonials = () => {
  const { t } = useLang();
  const { ref, visible } = useReveal();
  return (
    <section
      data-testid="testimonials-section"
      ref={ref}
      className={`py-20 md:py-32 reveal-up ${visible ? "in-view" : ""}`}
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-12 gap-y-8 lg:gap-x-12 mb-16 md:mb-20 items-end">
          <div className="col-span-12 lg:col-span-8">
            <div className="overline mb-6">{t.testimonials.overline}</div>
            <h2 className="editorial-h text-4xl md:text-5xl lg:text-6xl whitespace-pre-line">
              {t.testimonials.title}
            </h2>
          </div>
          <div className="col-span-12 lg:col-span-3 lg:col-start-10 flex items-center gap-3">
            <div className="flex">
              {[0, 1, 2, 3, 4].map((s) => (
                <svg key={s} width="16" height="16" viewBox="0 0 24 24" fill="black">
                  <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
                </svg>
              ))}
            </div>
            <span className="font-mono text-xs text-neutral-600">4.97 · Google</span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {t.testimonials.list.map((tt, i) => (
            <figure
              key={i}
              data-testid={`testimonial-${i}`}
              className="border border-neutral-200 bg-white p-8 md:p-10 flex flex-col"
            >
              <div className="font-serif text-7xl leading-none text-neutral-300 -mb-4">
                &ldquo;
              </div>
              <blockquote className="font-serif text-xl md:text-2xl leading-snug tracking-tight text-neutral-900 mb-8">
                {tt.quote}
              </blockquote>
              <figcaption className="mt-auto pt-6 border-t border-neutral-200 flex items-center gap-4">
                <img
                  src={PORTRAITS[i % PORTRAITS.length]}
                  alt={tt.name}
                  loading="lazy"
                  className="w-12 h-12 rounded-full object-cover grayscale"
                />
                <div>
                  <div className="text-sm font-medium">{tt.name}</div>
                  <div className="text-xs text-neutral-500">{tt.role}</div>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};
